export const groupAndAggregate = (data) => {
  const result = {}

  for (let i = 0; i < data.length; i += 1) {
    const {
      isBeingDeleted,
      groupName,
      key,
      isNewGroup,
      after,
      before,
      attrValue,
      isNewAttributeValue
    } = data[i]

    if (!result[groupName]) {
      result[groupName] = {
        key,
        groupName,
        isNewGroup,
        countOfGroupMembersAfter: isBeingDeleted ? after : 0,
        countOfGroupMembersBefore: before,
        attrValues: []
      }
    }

    if (!isBeingDeleted) {
      result[groupName].countOfGroupMembersAfter += after
    }

    result[groupName].attrValues.push({ id: `${attrValue}-${i}`, value: attrValue, isNewAttributeValue, isBeingDeleted })
  }

  const arrayResult = Object.values(result)
  arrayResult.sort((a, b) => a.groupName.localeCompare(b.groupName))
  return arrayResult
}
